<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="Mitsubishi O-Ring"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    Mitsubishi O-Ring
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/oring/oring-top-img.png"
            className="h-lg-280px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    MITSUBISHI CABLE 은 1917년 창립한 <br>
                    약 100년 역사를 가진 일본 회사 입니다.
                </h3>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    고무 O-Ring 제품은 일본 방위성에서 요청에 의해서 <br class="d-none d-md-block">
                    1958년 부터 생산 하고 있습니다.
                </p>
                <p class="page-text color-grey-51">
                    오랜 경험을 통해 얻은 노하우를 통해 핵심 역량인 <br class="d-none d-md-block">
                    ‘재료 복합 기술’ , ‘설계기술‘ , ‘생산 엔지니어링’에 근거한 <br class="d-none d-md-block">
                    획기적인 솔루션을 넓히고 있습니다. 
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="특장점">
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">
                        다양한 업계로부터 많은 추천과 관심을 받고 있습니다. <br>
                        기기 설계 단계에서 요구하시는 O-Ring 에 대한 문의를 항상 환영하고 있습니다.
                    </p>
                    <v-row>
                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon1.png"
                        iconWidth="49"
                        num="01">
                        소재 선택의 폭이 매우 넓음
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon2.png"
                        iconWidth="50"
                        num="02">
                        주문에 따른 최적의 디자인을 적용
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon3.png"
                        iconWidth="49"
                        num="03">
                        모든 분야에 고무 O-Ring (EPDM, Silicon, FKM) 과 <br class="d-none d-lg-block">
                        Metal O-Ring 공급 가능
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon4.png"
                        iconWidth="50"
                        num="04">
                        제품 라인에 폭넓은 산업 분야에 대응 가능
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout
                tit="Mitsubishi O-Ring"
                className="full">

                    <v-row class="my-n10 my-lg-n40">
                        <v-col cols="12" md="6" class="py-10 py-lg-40">
                            <image-detail
                            tit="Metal O-ring"
                            src="/images/sub/distributor/oring/oring-img3-1.png">

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-4 mb-lg-20">
                                    고온, 고압 등과 같은 가혹조건에서MITSUBISHI CABLE Metal O-ring 은 <br class="d-none d-lg-block">
                                    극한의 환경 조건인 고 진공 및 극 저온에서 높은 씰링 및 특성을 유지합니다.
                                </p>

                                <p class="bar-txt font-size-14 font-size-lg-16 color-grey-2c mb-2 mb-lg-8">
                                    - 270 °C ~ +700 °C에서 사용 가능
                                </p>
                                <p class="bar-txt font-size-14 font-size-lg-16 color-grey-2c">
                                    - 초고진공 (1.3×10-10Pa) 및 초고압에서 꾸준한 밀봉 성능 : 300MPa (약 3000kgf /cm2)
                                </p>

                            </image-detail>
                        </v-col>
                        <v-col cols="12" md="6" class="py-10 py-lg-40">
                            <image-detail
                            tit="Rubber Seal"
                            src="/images/sub/distributor/oring/oring-img3-2.png">

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10">
                                    많은 고무 sealing을 제조 / 공급 한 통합 sealing 재료 제조업체로서, 
                                    우리는 오랜 경험, 풍부한 재료 및 독특하고 최적의 형상 설계 기능을 최상의 혼합을 통해 
                                    다양한 조건에 부합하는 제품을 제공합니다.
                                </p>

                            </image-detail>
                        </v-col>
                    </v-row>

                </sub-line-layout>
            </v-container>
        </section>

        <div class="sub-section sub-section--last">
            <v-container>

                <inquiry
                src="/images/sub/distributor/oring/oring-img1.png"
                name="유 동현"
                tel="031-765-2268"
                mail="davidyoo@ist-co.kr"
                fax="031-765-2389"
                link="https://www.mitsubishi-cable.co.jp/en/products/group/seal/index.html"
                linkBg="/images/sub/distributor/oring/oring-img2.png">
                </inquiry>

            </v-container>
        </div>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/ko/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/ko/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/ko/sub/sub-inquiry.vue";
import ImageDetail from "@/components/client/ko/sub/sub-image-detail.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
        ImageDetail,
    },
};
</script>

<style lang="scss" scoped>
</style>